import { Fragment, h } from 'preact';
import { useContext } from 'preact/hooks';
import {
  ctaBorder,
  ctaColor,
  descriptionColor,
  displayUrlColor,
  headlineColor,
  linkBg,
} from '../../../facebook-video/creative/config';
import { PreviewContext } from '../contexts/previewContext';
import { useAdParameters } from '../hooks/useAdParameters';
import { useTextKeywords } from '../hooks/useTextKeywords';
import { getLocaleForLanguage } from '../locales';
import { LineClamp } from './line-clamp';

const lineHeight = {
  website: 12,
  headline: 20,
  description: 18,
};
const foot = {
  display: 'flex',
  color: 'inherit',
  background: linkBg,
  flex: '0 0 auto',
  alignItems: 'center',
};
const rows = {
  marginBlockStart: 12,
  marginBlockEnd: 12,
  marginInlineStart: 12,
  marginInlineEnd: 12,
  flex: '1 1 auto',
  overflow: 'hidden',
  maxHeight: `${lineHeight.headline + lineHeight.description + lineHeight.website}px`,
};
const url = {
  textTransform: 'uppercase',
  color: displayUrlColor,
  fontSize: '12px',
  lineHeight: `${lineHeight.website}px`,
};
const head = {
  color: headlineColor,
  fontSize: '14px',
  lineHeight: `${lineHeight.headline}px`,
  fontWeight: 'bold',
};
const desc = {
  color: descriptionColor,
  fontSize: '12px',
  lineHeight: `${lineHeight.description}px`,
};
const cta = {
  marginBlockStart: 12,
  marginBlockEnd: 12,
  marginInlineStart: 0,
  marginInlineEnd: 12,
  fontSize: '12px',
  lineHeight: '16px',
  color: ctaColor,
  textTransform: 'uppercase',
  paddingBlockStart: 3,
  paddingBlockEnd: 3,
  paddingInlineStart: 8,
  paddingInlineEnd: 8,
  borderRadius: '4px',
  border: `solid 1px ${ctaBorder}`,
  whiteSpace: 'nowrap',
  width: 'fit-content',
  maxWidth: '160px',
};

const ctaTextContainer = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export function FacebookFooter() {
  const preview = useContext(PreviewContext);
  const { config = {} } = useAdParameters<any>();
  const { display_url, headline, description, callToAction, show_footer } = config;

  const locale = getLocaleForLanguage(config.ctaLanguage);
  const headlineWithKeywords = useTextKeywords(headline, locale);
  const descriptionWithKeywords = useTextKeywords(description, locale);

  const visible = (!preview && headline && display_url) || (preview && show_footer);
  return (
    <Fragment>
      {visible && (
        <div style={foot}>
          <div style={rows}>
            {display_url && (
              <LineClamp lines={1} text={display_url} dots={false} lineHeight={lineHeight.website} style={url} />
            )}
            {headline && (
              <LineClamp
                lines={2}
                text={headlineWithKeywords}
                style={head}
                lineHeight={lineHeight.headline}
                dots={true}
                keywords
              />
            )}
            {description && (
              <LineClamp
                lines={1}
                text={descriptionWithKeywords}
                lineHeight={lineHeight.description}
                dots={true}
                style={desc}
                keywords
              />
            )}
          </div>
          {callToAction !== null && (
            <div style={cta}>
              <div style={ctaTextContainer}>{callToAction}</div>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
}
